import React, { useContext, useEffect, useRef, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { 
    Box,
    ClickAwayListener,
    Fade,
    Popper,
    Typography,
} from '@mui/material';
import { DataGridPro, GridCellEditStopReasons } from '@mui/x-data-grid-pro';
import WarningIcon from '@mui/icons-material/Warning';
import ProjectContext from '../../contexts/ProjectContext';
import GreenButton from '../buttons/GreenButton';
import ExpandedTextField from '../display/ExpandedTextField';
import {useFetch} from '../../components/auth/useFetch';


export default function OverrideWarningDialog(props) {

    const DIALOG_WIDTH = 720
    const DIALOG_HEIGHT = 584

    const { clickAway, downloadClick, exportName, open, payload } = props
    const { isAuthenticated } = useAuth0();
    const projectContext = useContext(ProjectContext);

    const [reportData, setReportData] = useState({})
    const fetchWithAuth = useFetch()

    useEffect(() => {
        isAuthenticated && (async () => {
        try {
            await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/assets/`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers:{
                    'X-Project-ID': projectContext?.project_db,
                    'Content-Type': 'application/json'
                },
            })
                .then((response) => response.json())
                .then((res) => {
                    setReportData(res)
                })
                .catch(e => {
                    console.error(e);
                })

        } catch (e) {
            console.error(e);
        }
        })();
    }, [isAuthenticated])

    const handleTextFieldChange = (e, section, item, itemKey) => {
        setReportData(prev => {
            return {
                ...prev,
                [section]: {
                    ...prev?.[section],
                    [item]: prev?.[section][item].map(i => 
                        i.hasOwnProperty(itemKey)
                        ?
                        { [itemKey]: e.target.value }
                        :
                        i
                    )

                }
            }
        })

    }

    return (
        <Popper
            id={open ? 'warning-popper' : undefined}
            open={open}
            transition
            disablePortal
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                zIndex: 100,
            }}
        >
        {({ TransitionProps }) => (
             <ClickAwayListener onClickAway={clickAway}>
                <Fade {...TransitionProps}>
                    <Box
                        width={'720px'}
                        height={'584px'}
                        display="flex"
                        flexDirection="column"
                        backgroundColor={'rgba(0,0,0,0.9)'}
                        sx={{
                            border: '2px solid rgba(50, 180, 65, 1)',
                            borderRadius: '8px'
                        }}
                    >
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'30px'}
                                sx={{flexDirection:'column'}}
                            >
                                <Typography color={'white'} component="span" variant="h7" align="center">
                                    You are about to override 
                                </Typography>
                                <Typography color={'white'} component="span" variant="h6" align="center">
                                    {exportName}  
                                </Typography>
                            </Box>
                            <Box
                                width={'100%'}
                                display={'flex'}
                            >
                                <Box
                                    width={'100%'}
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    px={3}
                                >
                                    <WarningIcon style={{fill: "rgba(200,200,0,0.8)"}} sx={{ fontSize: 20 }} />
                                    <Typography color={'rgba(200,200,0,0.8)'} variant="h7" align="center">
                                        {`By continuing, you understand the implications of this action and accept all liability associated with creating and delivering this export.`}
                                    </Typography>
                                </Box>
                            </Box>

                            <Box
                                display='flex'
                                flexDirection='column'
                                height='100%'
                                sx={{
                                    overflowY: 'auto',
                                }}
                            >
                                <Box
                                    display='flex'
                                    flexWrap='wrap'
                                >
                                    {(Object.keys(reportData?.summaryCard ?? {}))?.map(section => 
                                        (reportData?.summaryCard?.[section] ?? []).map(item => 
                                        <ExpandedTextField
                                            label={Object.entries(item)[0][0]}
                                            value={Object.entries(item)[0][1]}
                                            onChange={(e)=> handleTextFieldChange(e, 'summaryCard', section, Object.keys(item)[0])}
                                        /> 
                                        )
                                    )}
                                </Box>
                                <Box>

                                    <DataGridPro
                                        sx={{
                                            backgroundColor: '#101010', // Change the background color of the data grid
                                            borderColor: '#122218',
                                            '& .MuiDataGrid-root': {
                                                cursor: 'pointer', // Change the cursor to pointer when hovering over the data grid
                                            },
                                            '& .MuiDataGrid-cell:hover': {
                                                color: 'rgb(76, 146, 107)',
                                            },
                                            '& .MuiDataGrid-columnSeparator': {
                                                borderColor: 'green', // Make the separator green
                                                borderWidth: '2px', // Set the thickness of the separator
                                                visibility: 'visible', // Ensure the separator always visible
                                                '&:hover': {
                                                    borderColor: 'rgb(76, 146, 107)', // Ensure the separator stays green on hover
                                                },
                                            },
                                            '& .MuiDataGrid-columnHeaders': {
                                                backgroundColor: '#101010', // Change the column header background to black
                                            },
                                            '& .MuiDataGrid-columnHeader': {
                                                fontSize: '14px', // Customize the font size of the column headers
                                                color: 'white', // Change the column header color to white
                                                fontWeight: 'bold', // Make the column header text bold
                                                borderBottom: 'None', // Change the bottom line color of the column headers
                                            },
                                            '& .MuiDataGrid-row': {
                                                border: 'none', // Remove the row separator lines
                                            },
                                            '& .MuiDataGrid-rowCount': {
                                                color: 'white', // Change the background color of the selected row
                                            },
                                            '& .MuiDataGrid-selectedRowCount': {
                                                color: 'white', // Change the font color of the selected row count
                                            },
                                            '& .MuiDataGrid-cell': {
                                                border: 'none', // Remove the cell separator lines
                                                color: 'white', // Change the font color of the cells
                                                fontSize: '13px', // Make the cell text smaller
                                            },
                                            '& .MuiDataGrid-row:nth-of-type(odd)': {
                                                backgroundColor: '#161618', // Change the background color of odd rows
                                            },
                                            '& .MuiDataGrid-row:nth-of-type(even)': {
                                                backgroundColor: '#202020', // Change the background color of even rows
                                            },
                                            '& .MuiDataGrid-row:hover': {
                                                backgroundColor: 'rgba(76, 146, 107, 0.1)', // Change the hover color of the row to light green with reduced opacity
                                            },
                                            '& .MuiDataGrid-cell--withRenderer': {
                                                '& .MuiCheckbox-root': {
                                                    color: 'white', // Change the color of the checkbox
                                                    transform: 'scale(0.7)', // Make the checkbox smaller
                                                    '& .MuiSvgIcon-root': {
                                                        borderRadius: '50%', // Make the checkbox a circle
                                                    },
                                                    '&.Mui-checked': {
                                                        color: '#54a277', // Change the color of the selected checkbox to green
                                                    },
                                                },
                                            },
                                            '& .MuiDataGrid-columnHeaderCheckbox': {
                                                '& .MuiCheckbox-root': {
                                                    color: 'white', // Change the color of the checkbox in the column header
                                                    transform: 'scale(0.8)', // Make the checkbox smaller in the column header
                                                    '& .MuiSvgIcon-root': {
                                                        borderRadius: '50%', // Make the checkbox a circle in the column header
                                                    },
                                                    '&.Mui-checked': {
                                                        color: '#54a277', // Change the color of the selected checkbox to green in the column header
                                                    },
                                                },
                                            },
                                        }}
                                        rows={reportData?.assets ?? []}
                                        columns={
                                            (reportData?.table ?? [])?.map(item => {
                                                return {'field': item, 'headerName': reportData?.context?.[item], 'editable': true}
                                            })
                                        }
                                        onCellEditStop={(params, event) => {
                                            if (params.reason === GridCellEditStopReasons.cellFocusOut){
                                                event.defaultMuiPrevented = true;
                                            }
                                            else{
                                                params.row[params.field] = event.target.value || ''
                                                setReportData(prev => {
                                                    prev.assets.map((asset, index) => {
                                                        if(index === params.id){
                                                            return params.row
                                                        }
                                                        return asset
                                                    })
                                                    return prev
                                                })
                                            }
                                        }}

                                    />
                                </Box>
                            </Box>

                       
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'auto'}
                                marginBottom="30px"
                            >                                
                                <GreenButton variant='contained' onClick={() => downloadClick(reportData)} text='Continue' />
                                
                            </Box>
                        
                    </Box>
                </Fade>
             </ClickAwayListener>
        )}
        </Popper>
    )}